import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AmazonRdsForOracleCopySource } from 'app/model/pipeline/copysource/amazon-rds-for-oracle.copysource';
import { oracleCopySourceAdapts, OracleCopySourceAdapter } from './oracle.copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRdsForOracleCopySource),
    asynchronous: true,
    adapts: oracleCopySourceAdapts
})
export class AmazonRdsForOracleCopySourceAdapter extends OracleCopySourceAdapter {}
